<script>
    import { state, res, ui, prefs } from './stores.js';
    import Card from './Card.svelte';
    import { getCard, shuffle, getDeck, cardByID } from './game.js';
    import { createEventDispatcher } from 'svelte';
    import { draggable } from 'svelte-drag';
    import { tick } from 'svelte/internal';
    import { clearSelection } from './ui.js';

	const dispatch = createEventDispatcher();

    export let area;
    export let deck;
    export let player = false;
    export let cards;
    export let canShuffle = false;
    export let canHide = true;
    export let exactDeck = false;
    
    //$: if(getDeck($state, area, deck, player).length > 0) dispatch('close');
    function close(){
        clearSelection();
        cards = [];
        tick().then(() => {
            dispatch('close');
        })
        
    }

    async function close_shuffle(){
        clearSelection();
        cards = [];
        dispatch('close_shuffle');
        //await tick();
        //shuffle(getDeck($state, area, deck, player));
    }

    let showDeck;
    $: showDeck = exactDeck || getDeck($state, area, deck, player)
    $: if(showDeck && showDeck.length == 0) close();
    //$: console.log('deck', showDeck, cards)
    
</script>

{#if showDeck && showDeck.length > 0}
    <div class="look" use:draggable>
        {#if deck && !exactDeck}
            <div class="look_row">
                {#if !isNaN(parseInt(deck))}
                    cards beamed to '{cardByID(deck).name}'
                {:else}
                    {deck} deck
                {/if}
            </div>
        {/if}
        <div class="look_row">
            <!--{#each cards.filter(c => deck.includes(c)) as card, index (card)}-->
            {#each showDeck as c, i}
                {#if !cards || cards.includes(i)}
                    <div><Card single partOfLook {c} bind:deck={showDeck} {i} /></div>
                {/if}
            {/each}
        </div>
        {#if canHide}
            <div class="look_row">
                <button style="font-size: {$prefs.buttonScale * 1.5}vmin; " on:click={close}>Close</button>
                {#if canShuffle}
                    <button style="font-size: {$prefs.buttonScale * 1.5}vmin; " on:click={close_shuffle}>Close and shuffle</button>
                {/if}
            </div>
        {/if}
    </div>
{/if}

<style>
   .look {
		position: fixed;
		z-index: 500;
		left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        pointer-events: visible;
		padding: 3vmin;
		padding-bottom: 1vmin;
		/*transform: translate(-50%, -50%);*/
        height: fit-content;
        width: fit-content;
		max-height: 90vh;
		max-width: 90vw;
		min-width: 60vw;
		/*padding: 3vmin;*/
		padding-bottom: 1vmin;
		transform: translate(-50%, -50%);
		max-height: 90vh;
		max-width: 90vw;
		overflow-y: auto;
		backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
		color: black;
		/*box-shadow: 0 0 5px 5px black;*/
        color: white;
	}
    .look_row {
		width: 100%;
		font-size: 2vmin;
		display: flex;
        max-width: 90vw;
        flex-wrap: wrap;
		align-items: center;
		justify-content: start;
        font-weight: bold;
		/*padding: 1vmin;*/
	}
</style>